import { Theme, css } from '@emotion/react';

export const titleWrapper = (theme: Theme) => css`
  display: flex;
  align-items: center;
`;

export const checkmark = (theme: Theme) => css`
  margin-left: ${theme.spacing(1)}px;
  color: ${theme.colors.fgSuccessBase};
`;
